<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Settings</li>
    </ol>
  </nav>
  <form>
    <div class="row">
      <div class="col">
        <ul class="list-inline tab-list deskContent">
          <ng-container *ngFor="let om of ordersMainMenu">
            <li *ngIf="om.additional === 'N'" class="list-inline-item">
              <a (click)="populateTabData(om.tabClicked);"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
          </ng-container>
        </ul>
        <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
                [ngModelOptions]="{standalone: true}" (change)="populateTabData(userDrop2);" style="width: 140px;"
                required>
          <option *ngFor="let u of ordersMainMenu" [ngValue]="u.tabClicked">{{u.displayName}}</option>
        </select>
      </div>
    </div>
    <div class="row hide-sec" [ngClass]="{'show-sec': tabClicked === 'myAccount'}">
      <div class="inner-box deskContent">
        <div class="row mt-3">
          <div class="col-md-4 required">
            <label class="control-label" for="firstName">Name</label>
            <input type="text" id="firstName" [(ngModel)]="account.name" class="form-control"
                   [ngModelOptions]="{standalone: true}" disabled>
          </div>
          <div class="col-md-4">
            <div class="form-group required">
              <label class="control-label" for="status">status</label>
              <input type="text" id="status" [(ngModel)]="account.status" class="form-control"
                     [ngModelOptions]="{standalone: true}" disabled>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group required">
              <label class="control-label" for="email">Email</label>
              <input type="text" id="email" [(ngModel)]="account.email" class="form-control"
                     [ngModelOptions]="{standalone: true}" disabled>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group required">
              <label class="control-label" for="phoneNumber">Phone Number</label>
              <input type="text" id="phoneNumber" [(ngModel)]="account.mobile" class="form-control"
                     [ngModelOptions]="{standalone: true}" disabled>
            </div>
          </div>
          `
        </div>
      </div>
    </div>
    <div class="row hide-sec" [ngClass]="{'show-sec':tabClicked === 'passwordManagement'}">
      <div class="inner-box deskContent ">
        <div>
          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="currentPassword">Current Password</label>
                <input type="password" id="currentPassword" maxlength="50" [(ngModel)]="currentPassword"
                       class="form-control"
                       (blur)="typeCurrentPwd()" [ngClass]="{'is-invalid':currentPwdError}"
                       [ngModelOptions]="{standalone: true}" required>
                <div id="currentPwdError" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!currentPwdError">{{currentPwdError}}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="newPassword">New Password</label>
                <input type="password" id="newPassword" maxlength="50" [(ngModel)]="newPassword" class="form-control"
                       (blur)="typeNewPwd()" [ngClass]="{'is-invalid':newPwdError}"
                       [ngModelOptions]="{standalone: true}"
                       required>
                <div id="newPwdError" class="invalid-feedback d-block shift-invalid-login" [hidden]="!newPwdError">
                  {{newPwdError}}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="confirmPassword">Confirm Password</label>
                <input type="password" id="confirmPassword" maxlength="50" [(ngModel)]="confirmPassword"
                       class="form-control"
                       (blur)="typeConfirmPwd()" [ngClass]="{'is-invalid':confirmPwdError}"
                       [ngModelOptions]="{standalone: true}" required>
                <div id="confirmPwdError" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!confirmPwdError">{{confirmPwdError}}
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col text-right">
              <button type="button" (click)="submitChangePassword()" id="change" class="btn btn-orange">Change</button>
            </div>
          </div>
        </div>
      </div>
      <div class="inner-box MobileContent">
        <div>
          <label class="text-black mb-3"><b>Change Password</b></label>
          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="currentPassword">Current Password</label>
                <input type="password" id="currentPasswordMob" maxlength="50" [(ngModel)]="currentPassword"
                       class="form-control"
                       (blur)="typeCurrentPwd()" [ngClass]="{'is-invalid':currentPwdError}"
                       [ngModelOptions]="{standalone: true}" required>
                <div id="currentPwdErrorMob" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!currentPwdError">{{currentPwdError}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="newPassword">New Password</label>
                <input type="password" id="newPasswordMob" maxlength="50" [(ngModel)]="newPassword" class="form-control"
                       (blur)="typeNewPwd()" [ngClass]="{'is-invalid':newPwdError}"
                       [ngModelOptions]="{standalone: true}"
                       required>
                <div id="newPwdErrorMob" class="invalid-feedback d-block shift-invalid-login" [hidden]="!newPwdError">
                  {{newPwdError}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 required">
              <div class="form-group ">
                <label class="control-label" for="confirmPassword">Confirm Password</label>
                <input type="password" id="confirmPasswordMob" maxlength="50" [(ngModel)]="confirmPassword"
                       class="form-control"
                       (blur)="typeConfirmPwd()" [ngClass]="{'is-invalid':confirmPwdError}"
                       [ngModelOptions]="{standalone: true}" required>
                <div id="confirmPwdErrorMob" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!confirmPwdError">{{confirmPwdError}}
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col text-right">
              <button type="button" (click)="submitChangePassword()" id="changeMob" class="btn btn-orange">Change
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </form>
</section>
